import { useState } from 'react';
import type { Product } from '../../../types/product';

export function useProductSingleSelection() {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const handleSelectProduct = (product: Product) => {
    setSelectedProduct(product);
  };

  return {
    selectedProduct,
    handleSelectProduct,
  };
}
